var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubewhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "YouTube - Negative"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8805 3.60039C11.8805 3.60039 11.7633 2.77305 11.4023 2.40977C10.9453 1.93164 10.4344 1.9293 10.2 1.90117C8.52188 1.7793 6.00234 1.7793 6.00234 1.7793H5.99766C5.99766 1.7793 3.47813 1.7793 1.8 1.90117C1.56563 1.9293 1.05469 1.93164 0.597656 2.40977C0.236719 2.77305 0.121875 3.60039 0.121875 3.60039C0.121875 3.60039 0 4.57305 0 5.54336V6.45273C0 7.42305 0.119531 8.3957 0.119531 8.3957C0.119531 8.3957 0.236719 9.22305 0.595312 9.58633C1.05234 10.0645 1.65234 10.048 1.91953 10.0996C2.88047 10.191 6 10.2191 6 10.2191C6 10.2191 8.52188 10.2145 10.2 10.0949C10.4344 10.0668 10.9453 10.0645 11.4023 9.58633C11.7633 9.22305 11.8805 8.3957 11.8805 8.3957C11.8805 8.3957 12 7.42539 12 6.45273V5.54336C12 4.57305 11.8805 3.60039 11.8805 3.60039ZM4.76016 7.55664V4.18398L8.00156 5.87617L4.76016 7.55664Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubewhite);
export default __webpack_public_path__ + "static/media/youtubewhite.9a4aa637b491e265c5729424ca5a8850.svg";
export { ForwardRef as ReactComponent };